import { v4 as uuidv4 } from 'uuid';

const servicesOneData = [
    {
        id: uuidv4(),
        heading: 'Clinical Applications',
        btnText: 'Learn More',
        link: '/clinical-applications',
        items: [
            'Graft Engineering',
            'Immunotheropy',
            'Tissue Engineering',
            'Therapeutic Procedures',
            'CART Cell Manufacturing'
        ]
    },

    {
        id: uuidv4(),
        heading: 'cGMP Products',
        btnText: 'Learn More',
        link: '/cgmp-Products',
        items: [
            'Mesenchymal Stem Cells',
            'Tregulatory Cells',
            'Natural Killer Cells',
            'Dendritic Cells',
            'Pluripotent Stemcell Expansion'
        ]
    },

    {
        id: uuidv4(),
        heading: 'Turn Key Projects',
        btnText: 'Learn More',
        link: '/turnKeyProject',
        items: [
            'BMT Unit',
            'GMP Lab',
            'CART cell / NK cell Manufacturing Platform',
            'cGMP product manufacturing Consultation',
        ]
    },
];

export default servicesOneData;
